module.exports = __webpack_public_path__ + "media/images/seller-guide-carmen-thumb-5a71bc7d7c809ecbc2dfda190b1a5b77.png";